import { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  // Check if a path is active (current page)
  const isActive = (path) => {
    if (path === '/') {
      return location.pathname === '/';
    }
    return location.pathname.startsWith(path);
  };

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleNavClick = (path) => {
    setMobileMenuOpen(false);
    navigate(path);
    window.scrollTo(0, 0);
  };

  return (
    <>
      {/* Mantra Strip */}
      <div className="mantra-strip" data-testid="mantra-strip">
        ॥ सत्यमेव जयते ॥ &ensp;·&ensp; Rooted in the Vedic tradition. Committed to your clarity, always.
      </div>
      
      {/* Navigation */}
      <nav className={isScrolled ? 'scrolled' : ''} data-testid="main-navigation">
        <div className="nav-inner">
          <Link to="/" className="nav-brand" onClick={() => window.scrollTo(0, 0)} data-testid="nav-brand">
            <span className="nav-brand-main">Amatya</span>
            <span className="nav-brand-sub">अमात्य — आपका दिव्य परामर्शदाता</span>
          </Link>
          <ul className={`nav-links ${mobileMenuOpen ? 'mobile-open' : ''}`}>
            <li><Link to="/anusthan" className={isActive('/anusthan') ? 'nav-active' : ''} onClick={() => handleNavClick('/anusthan')} data-testid="nav-anusthan">Anusthan</Link></li>
            <li><Link to="/bhoj-daan" className={isActive('/bhoj-daan') ? 'nav-active' : ''} onClick={() => handleNavClick('/bhoj-daan')} data-testid="nav-bhoj-daan">Bhoj & Daan</Link></li>
            <li><Link to="/about" className={isActive('/about') ? 'nav-active' : ''} onClick={() => handleNavClick('/about')} data-testid="nav-about">About Us</Link></li>
            <li><Link to="/services" className={isActive('/services') ? 'nav-active' : ''} onClick={() => handleNavClick('/services')} data-testid="nav-services">Services</Link></li>
            <li><Link to="/stories" className={isActive('/stories') ? 'nav-active' : ''} onClick={() => handleNavClick('/stories')} data-testid="nav-stories">Stories</Link></li>
            <li><Link to="/faq" className={isActive('/faq') ? 'nav-active' : ''} onClick={() => handleNavClick('/faq')} data-testid="nav-faq">FAQ</Link></li>
            <li><Link to="/my-consultation" className={isActive('/my-consultation') ? 'nav-active' : ''} onClick={() => handleNavClick('/my-consultation')} data-testid="nav-my-consultation">My Consultation</Link></li>
            <li>
              <button onClick={() => handleNavClick('/begin-journey')} className={`nav-btn ${isActive('/begin-journey') ? 'nav-btn-active' : ''}`} data-testid="nav-begin-btn">
                Begin Journey
              </button>
            </li>
          </ul>
          <button 
            className="mobile-menu-btn" 
            data-testid="mobile-menu-btn"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            {mobileMenuOpen ? '✕' : '☰'}
          </button>
        </div>
      </nav>
    </>
  );
};

export default Header;
